"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _reactRouter = require("react-router");
var _reactRedux = require("react-redux");
var _routes = require("../util/routes");
var _signinUrl = _interopRequireWildcard(require("../util/signinUrl"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function routeStateSelector(_ref) {
  var baseUrl = _ref.baseUrl,
    isLoggedIn = _ref.userPrefs.isLoggedIn;
  return {
    baseUrl: baseUrl,
    isLoggedIn: isLoggedIn
  };
}

/**
 * Component to sign user out on client side.
 * Sign out happens when:
 *   1) forceSignOut is in route config
 *   2) user is not signed in for non-anonymous route
 */
function RouteHandler() {
  var _useSelector = (0, _reactRedux.useSelector)(routeStateSelector),
    isLoggedIn = _useSelector.isLoggedIn,
    baseUrl = _useSelector.baseUrl;
  var matchingRoutes = (0, _reactRouter.useMatches)();

  // useEffect will run every time location changes
  (0, _react.useEffect)(function () {
    var _location = location,
      pathname = _location.pathname;

    // Check if on sign in page
    var signinUrl = (0, _signinUrl.default)(baseUrl).toLowerCase();
    var isSignIn = signinUrl === pathname;

    // Check for custom flags
    var forcedSignOut = (0, _routes.isForcedSignOut)(matchingRoutes);
    var anonymous = (0, _routes.isAnonymous)(matchingRoutes);

    // Redirect if forceSignOut flag is there or its not an anonymous route and the user is logged in
    var isRedirect = forcedSignOut || !anonymous && !isLoggedIn;
    if (isRedirect && !isSignIn) {
      // Redirect to sign in
      var targetUrl = pathname ? "?targetURL=".concat(encodeURI(pathname)) : '';
      (0, _signinUrl.redirectToSignin)(baseUrl, targetUrl);
    }
  }, [matchingRoutes]);
  return null;
}
var _default = exports.default = RouteHandler;